/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Additional price on an order entry set by the pricing engine. PRIOR type provides the original price before discounts, used for strikethrough display in the storefront (e.g. 500 kr crossed out -> 450 kr).
 * @export
 * @interface SAPAdditionalPrice
 */
export interface SAPAdditionalPrice {
    /**
     * Additional price type provided by the pricing engine.
     * @type {string}
     * @memberof SAPAdditionalPrice
     */
    type?: string;
    /**
     * Price amount provided by the pricing engine in addition to the standard product price.
     * @type {number}
     * @memberof SAPAdditionalPrice
     */
    price?: number;
}

/**
 * Check if a given object implements the SAPAdditionalPrice interface.
 */
export function instanceOfSAPAdditionalPrice(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPAdditionalPriceFromJSON(json: any): SAPAdditionalPrice {
    return SAPAdditionalPriceFromJSONTyped(json, false);
}

export function SAPAdditionalPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPAdditionalPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'price': !exists(json, 'price') ? undefined : json['price'],
    };
}

export function SAPAdditionalPriceToJSON(value?: SAPAdditionalPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'price': value.price,
    };
}

